/** Contact form validation script */

const form = document.getElementById('contact-form');
const formWrap = document.getElementById('contact-form-wrap');
const errors = new Set();
const formInputIds = ['name', 'email', 'company', 'message', 'nda', 'newsletterSubscription'];

function validateInput(id) {
  const {value, rowCell, errorRows} = getFormElements(id);
  errors.delete(id);
  if (errorRows.length) {
    for (let row of errorRows) {
      row.remove();
    }
  }
  const newError = document.createElement('div');
  newError.className = 'form-row-error';
  if (value.length === 0 || (value || '').trim().length === 0) {
    errors.add(id);
    if (id === 'message') {
      newError.innerHTML = 'Please fill in your message or question';
    } else {
      newError.innerHTML = `Please fill in your ${id}`;
    }
  } else if (id === 'email' && !validateEmail(value)) {
    errors.add(id);
    newError.innerHTML = 'Enter a valid email address'
  }
  rowCell.appendChild(newError);
}

function validateEmail(email) {
  const pattern = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;
  return pattern.test(email);
}

function getFormElements(id) {
  const value = document.getElementById(id).value;
  const checked = document.getElementById(id).checked;
  const rowCell = document.getElementById(id).parentElement;
  const errorRows = rowCell.getElementsByClassName('form-row-error');
  return {value, checked, rowCell, errorRows};
}

function sendEmail(data) {
  const url = 'https://2muchcoffee.com/send-mail';
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => response.json())
    .then(() => {
      sendAnalyticsEvent('Contact', {
        // Google specific param
        event_category: 'Contact Us Form',
        // Facebook pixel specific param
        content_category: 'Contact Us Form',
      });
      return addThanksElement(true);
    })
    .catch(() => {
      addThanksElement(false);
    });
}

function addThanksElement(isSuccess) {
  const thanksElement = document.createElement('div');
  thanksElement.className = 'form-thanks';
  const img = document.createElement('img');
  img.src = isSuccess
    ? '/blog/assets/img/request-success.svg'
    : '/blog/assets/img/request-fail.svg';
  thanksElement.appendChild(img);
  const title = document.createElement('h2');
  const text = document.createElement('div');
  const link = document.createElement('a');
  let titleClass;
  let titleContent;
  let textClass;
  let textContent;
  let linkClass;
  let linkContent;
  textClass = 'form-thanks-text';
  linkClass = 'form-thanks-link';
  if (isSuccess) {
    titleClass = 'form-thanks-title';
    titleContent = 'Thank you for your inquiry!';
    textContent = 'We will contact you shortly';
    linkContent = 'Send another message';
  } else {
    titleClass = 'form-error-title';
    titleContent = 'Something went wrong!';
    linkContent = `Let's try again`;
  }
  title.className = titleClass;
  title.innerHTML = titleContent;
  text.className = textClass;
  text.innerHTML = textContent;
  link.className = linkClass;
  link.innerHTML = linkContent;
  thanksElement.appendChild(title);
  textContent ? thanksElement.appendChild(text) : null;
  thanksElement.appendChild(link);
  formWrap.appendChild(thanksElement);
  addThanksLinksListeners();
}

function removeThanksElement() {
  const elements = document.getElementsByClassName('form-thanks');
  if (elements.length) {
    for (let element of elements) {
      element.remove();
    }
  }
}

form && form.addEventListener('submit', (event) => {
  event.preventDefault();
  formInputIds.forEach(id => {
    validateInput(id);
  });
  if (errors.size) {
    return;
  }
  const formValuesObj = formInputIds.reduce((acc, id) => {
    let value;
    if (['nda', 'newsletterSubscription'].includes(id)) {
      value = getFormElements(id).checked;
    } else {
      value = getFormElements(id).value;
    }
    return {
      ...acc,
      [id]: value
    }
  }, {});
  formValuesObj.to = 'EMAIL_TO_SALES';
  formValuesObj.subject = `New request from ${formValuesObj.email}`;
  sendEmail(formValuesObj);
  form.reset();
});

function addThanksLinksListeners() {
  const links = document.getElementsByClassName('form-thanks-link');
  if (links.length) {
    for (let link of links) {
      link.addEventListener('click', () => removeThanksElement());
    }
  }
}

